import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClusterStyle } from '@agm/js-marker-clusterer/services/google-clusterer-types';
import crossfilter from 'crossfilter2/crossfilter';
import { get, orderBy } from 'lodash';
import { SelectItem } from 'primeng/api';
import { Table, LazyLoadEvent } from 'primeng';
import { IFacetedInboxTask, IFacetedJob } from '../../interfaces/faceted-inbox-task';
import { LoggerService, VehicleAddressService } from '../../services';
import { TaggedLogger } from '../../services';
import { VmeInboxJobsService } from '../../services';
import { Location } from '@angular/common';
import { ITaskInfo } from '../../interfaces/task-info';
import { TaskService } from '../../services';
import { JobStatus } from '../../enums/job-status';
import { MapService } from '../../services';
import moment from 'moment';

@Component({
  selector: 'supplier-schedule-planning-tool',
  styleUrls: ['./supplier-schedule-planning-tool.component.scss'],
  templateUrl: './supplier-schedule-planning-tool.component.html',
  //  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupplierSchedulePlanningToolComponent implements OnInit, AfterViewChecked {
  private logger: TaggedLogger;
  @Output() jobSelectionChanged = new EventEmitter<any>();
  @Output() onGridAction = new EventEmitter<any>();

  public type_inboxSupplierToBeConfirmed = 1;
  public type_inboxCombine = 4;
  public type_inboxDeploy = 11;
  staticMapSize = '300x200';
  showSearch: boolean = false;
  isFacetOpen: {} = {};
  public selectedJobs: IFacetedJob[] = [];

  loadingSelection: boolean = false;

  polylinePoints: any[];
  latLngPoints: any[];

  // the entire resultset
  allData: IFacetedInboxTask[];

  // the crossfiltered resultset
  crossFilterData: any;

  // each group creates a selection table in the UI
  filterGroups: any[] = [];

  // the dimensions of the crossfiltered data
  filterDimensions: any[];

  // the selected filter items in each list
  selectedFilters: any[] = [];

  inputTasks: ITaskInfo[] = [];

  // this is all data filtered by the currently selected items within dimensions
  // crossfilter uses this to create dimensions which will then reflect the selected items
  workingSet: IFacetedInboxTask[] = [];
  resultSet: IFacetedInboxTask[]; // the rows shown in the paginated grid

  // sort on value descending or key ascending
  sortType: boolean[] = [];

  // selected job in the results grid
  selectedJob: IFacetedInboxTask;

  // paginated grid properties
  rowsInPage: number = 99;
  firstRow: number = 0;
  sortField: string;
  sortOrder: number = 0;

  isLoading: boolean = true;
  showLogging: boolean = true;

  // this controls whether the search filter per facet (if any) is applied when ngAfterContentChecked is run
  // the facets listview will not respond if called from any other method since it needs to wait for content to be recreated in the view
  refreshTableSearchFilter: boolean = false;

  pickupIconStyles: ClusterStyle[];
  dropoffIconStyles: ClusterStyle[];

  loadedFromQuery: boolean = false;

  filterDefinitions: any[] = [
    {
      propertyName: 'customerTaskType',
      title: 'Move Type',
    },
    {
      propertyName: 'customerName',
      title: 'Customer',
      searchable: true,
    },
    /*
    {
      propertyName: "scheduledDate", title: "Scheduled Date", isDate: true
    },
     */
    /*
    {
      propertyName: "pickupZoneName", title: "Collection Areas", searchable: true
    },
    {
      propertyName: "deliveryZoneName", title: "Delivery Areas", searchable: true
    },
     */
    {
      propertyName: 'checklistCategoryName',
      title: 'Checklist Category',
      searchable: true,
    },
    {
      propertyName: 'checklistSubCategoryName',
      title: 'Checklist SubCategory',
      searchable: true,
    },
    {
      propertyName: 'pickupAreaName',
      title: 'Collection Region',
      searchable: true,
    },
    {
      propertyName: 'deliveryAreaName',
      title: 'Delivery Region',
      searchable: true,
    },
    /*
    {
      propertyName: "latestPickupDate",
      title: "Days Left",
      dateDiff: true,
      tooltip: "Days left until latest pickup date"
    },

     */
    {
      propertyName: 'latestPickupDate',
      title: 'Latest Collection',
      isDate: true,
      noRangeCheck: true,
    },
    {
      propertyName: 'latestDropOffDate',
      title: 'Latest Delivery',
      isDate: true,
      noRangeCheck: true,
    },
    {
      propertyName: 'vehicleWeight',
      title: 'Weight Category',
      ranges: [
        { min: 1, max: 3500, groupValue: 1, label: 'Less than 3.5t' },
        { min: 3500, max: 7500, groupValue: 3.5, label: '3.5t - 7.5t' },
        { min: 7500, max: 18000, groupValue: 7.5, label: '7.5t - 18t' },
        { min: 18000, max: 44000, groupValue: 18, label: '18t - 44t' },
      ],
    },
    {
      propertyName: 'moveDistance',
      title: 'Journey Length',
      ranges: [
        { min: 0, max: 10, groupValue: 1, label: 'Up to 10 miles' },
        { min: 10, max: 20, groupValue: 2, label: '10 - 20 miles' },
        { min: 20, max: 50, groupValue: 3, label: '20 - 50 miles' },
        { min: 50, max: 100, groupValue: 4, label: '50 - 100 miles' },
        { min: 100, max: 200, groupValue: 5, label: '100 - 200 miles' },
        { min: 200, max: 300, groupValue: 6, label: '200 - 300 miles' },
        { min: 300, max: 400, groupValue: 7, label: '300 - 400 miles' },
        { min: 400, max: 10000, groupValue: 8, label: '400+ miles' },
      ],
    },
    {
      propertyName: 'pickupDistance1',
      title: 'Pickup Distance from',
      placeholder: 'Postcode/Town',
      input: true,
      ranges: [
        { min: null, max: null, groupValue: 1, label: 'N/A' },
        { min: 0, max: 10, groupValue: 2, label: 'Up to 10 miles' },
        { min: 10, max: 20, groupValue: 3, label: '10 - 20 miles' },
        { min: 20, max: 50, groupValue: 4, label: '20 - 50 miles' },
        { min: 50, max: 100, groupValue: 5, label: '50 - 100 miles' },
        { min: 100, max: 200, groupValue: 6, label: '100 - 200 miles' },
        { min: 200, max: 300, groupValue: 7, label: '200 - 300 miles' },
        { min: 300, max: 400, groupValue: 8, label: '300 - 400 miles' },
        { min: 400, max: 10000, groupValue: 9, label: '400+ miles' },
      ],
    },
    {
      propertyName: 'dropoffDistance1',
      title: 'Dropoff Distance from',
      placeholder: 'Postcode/Town',
      input: true,
      ranges: [
        { min: null, max: null, groupValue: 1, label: 'N/A' },
        { min: 0, max: 10, groupValue: 2, label: 'Up to 10 miles' },
        { min: 10, max: 20, groupValue: 3, label: '10 - 20 miles' },
        { min: 20, max: 50, groupValue: 4, label: '20 - 50 miles' },
        { min: 50, max: 100, groupValue: 5, label: '50 - 100 miles' },
        { min: 100, max: 200, groupValue: 6, label: '100 - 200 miles' },
        { min: 200, max: 300, groupValue: 7, label: '200 - 300 miles' },
        { min: 300, max: 400, groupValue: 8, label: '300 - 400 miles' },
        { min: 400, max: 10000, groupValue: 9, label: '400+ miles' },
      ],
    },
    {
      propertyName: 'vehicleInfo',
      title: 'Vehicle',
      searchable: true,
    },
  ];

  @ViewChildren('facetTable') facetTables: QueryList<Table>;

  settingFilters: boolean = false;
  tooltipCode: string;
  loadingMap: {} = {};
  mapCode: {} = {};
  showingMap: {} = {};

  public userLongitude: {} = {};
  public userLatitude: {} = {};

  public userLocation: {} = {};
  isFacetLoading: {} = {};

  constructor(
    private router: Router,
    private vmeInboxjobsService: VmeInboxJobsService,
    private changeDetectorRef: ChangeDetectorRef,
    private mapService: MapService,
    private taskService: TaskService,
    loggerService: LoggerService,
    private activatedRoute: ActivatedRoute,
    private vehicleAddressService: VehicleAddressService,
    private readonly location: Location,
  ) {
    this.logger = loggerService.taggedLogger('FacetedFiltering');
  }

  async ngOnInit() {
    this.logger.trace('OnInit');
    this.isLoading = true;
    await this.load();
  }

  ngAfterViewChecked() {
    this.logger.trace('AfterViewChecked');
    if (this.refreshTableSearchFilter) {
      for (let index = 0; index < this.filterDefinitions.length; index++) {
        if (this.filterDefinitions[index].tableFilter) {
          let tf = this.filterDefinitions[index].tableFilter;
          let facetTable = this.facetTables.toArray()[index];

          facetTable.filter(tf.value, tf.field, tf.method);
        }
      }

      this.refreshTableSearchFilter = false;
      this.populateWorkingSet();
    }
  }

  clearDimensions() {
    for (let i = 0; i < this.filterDimensions.length; i++) {
      if (!this.selectedFilters[i]) this.filterDimensions[i].filterAll();
    }
  }

  async showMap(event, i, t) {
    event.stopPropagation();

    this.showingMap[i] = !this.showingMap[i];

    if (this.showingMap[i]) {
      this.loadingMap = true;
      const code = await this.getMap(t);
      this.mapCode[i] = code;
      this.loadingMap = false;
    }
  }

  async getMap(t) {
    const polylines = await this.mapService.GetRoutePolyLine({
      fromLatitude: t.fromLatitude,
      fromLongitude: t.fromLongitude,
      toLatitude: t.toLatitude,
      toLongitude: t.toLongitude,
      departureTime: t.earliestPickupDate,
    });

    const task = {
      pickupLocation: { latitude: t.fromLatitude, longitude: t.fromLongitude },
      dropoffLocation: { latitude: t.toLatitude, longitude: t.toLongitude },
    } as ITaskInfo;

    return this.mapService.getStaticMapPath(
      'roadmap',
      this.mapService.buildMarkersFromTask(task),
      this.staticMapSize,
      1,
      null,
      [polylines],
    );
  }

  filterRowSelectionChanged(index: number) {
    this.loadingSelection = true;

    this.clearDimensions();
    this.setDimensionFilter(index);

    this.populateWorkingSet();

    this.loadingSelection = false;
  }

  setDimensionFilter(index: number) {
    this.logger.trace(
      `Setting dimension filters on ${index} - selected: `,
      this.selectedFilters[index],
    );

    //flatten the values in the selection array
    const selectedFilter = get(this.selectedFilters, `[${index}]`);
    const selectedFilterValues =
      selectedFilter && typeof selectedFilter.map === 'function'
        ? selectedFilter.map((x) => {
            return x.value;
          })
        : [];

    if (selectedFilterValues && selectedFilterValues.length > 0) {
      let definition = this.filterDefinitions[index];
      if (!definition) return;

      if (!definition.rangeDivisor && !definition.dateDiff && !definition.ranges) {
        if (!definition.isDate) {
          this.filterDimensions[index].filterFunction((dv) => {
            return selectedFilterValues.indexOf(dv) >= 0;
          });
        } else {
          this.filterDimensions[index].filterFunction((x) => {
            return selectedFilterValues.indexOf(x.toISOString()) >= 0;
          });
        }
      } else if (definition.rangeDivisor) {
        this.filterDimensions[index].filterFunction((d) => {
          selectedFilterValues.forEach((value) => {
            let min = value - (definition.rangeDivisor - 1);
            let max = value + 1;

            const result = d >= min && d <= max;

            if (result) return result;
          });

          return false;
        });
      } else if (definition.dateDiff) {
        this.filterDimensions[index].filterFunction((x) => {
          let today = moment().startOf('day');
          let xDate = moment(x).startOf('day');
          let days = xDate.diff(today, 'days');

          return selectedFilterValues.indexOf(days) >= 0;
        });
      } else if (definition.ranges) {
        this.filterDimensions[index].filterFunction((x) => {
          let result: boolean = false;

          // get min and max range from value 1
          for (let i = 0; i < definition.ranges.length; i++) {
            let range = definition.ranges[i];

            result =
              ((x >= range.min && x < range.max) || (range.min == x && range.max == x)) &&
              selectedFilterValues.indexOf(range.groupValue) >= 0;

            if (result) break;
          }

          return result;
        });
      }
    } else if (this.filterDimensions[index]) {
      this.filterDimensions[index].filterAll();
    }

    this.refreshTableSearchFilter = true;
  }

  populateWorkingSet(saveSelection: boolean = true) {
    // reset groups according to filtered dimensions
    this.setSelections();

    // repopulate the results grid using the selected dimension filters
    this.workingSet = this.crossFilterData.allFiltered();

    this.firstRow = 0;
    this.setResults();

    if (saveSelection) this.saveToStorage();
  }

  async load() {
    this.logger.trace('load()');

    this.filterGroups = [];
    this.filterDimensions = [];
    this.allData = await this.vmeInboxjobsService.facetedJobSearch({
      jobStatus: JobStatus.Created,
      notOnHold: true,
      hasSupplier: false,
    });

    this.updateFacets();
  }

  updateFacets() {
    this.updateDistances();

    this.crossFilterData = crossfilter(this.allData);
    this.workingSet = this.crossFilterData.allFiltered();
    this.isLoading = false;
    this.setDimensions();
    this.setResults();
    this.loadFromStorage();
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.firstRow = event.first;
    this.rowsInPage = event.rows;
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;

    // get data from workingset according to row values
    if (this.workingSet && this.workingSet.length > 0) this.setResults();
  }

  setResults() {
    let seq = 0;

    this.resultSet = this.workingSet
      .sort((a, b) => {
        return this.dateSort(b.scheduledDate, a.scheduledDate);
      })
      .slice(this.firstRow, this.firstRow + this.rowsInPage);

    this.resultSet.forEach((x) => (x.sequence = ++seq));

    // clear all filters if no results (can happen with data changes)
    if (this.resultSet.length == 0) {
      this.clearAllFilters();
    }
  }

  stringSort(a, b): number {
    let str1 = !a ? '' : a.toString();
    let str2 = !b ? '' : b.toString();

    if (this.sortOrder == 1) return str1.localeCompare(str2);
    else return str2.localeCompare(str1);
  }

  dateSort(a, b): number {
    if (this.sortOrder == 1) return moment(a).unix() - moment(b).unix();
    else return moment(b).unix() - moment(a).unix();
  }

  numberSort(a, b): number {
    return this.sortOrder == 1 ? a - b : b - a;
  }

  setDimensions() {
    let nullData = 'Not set';
    let nullDataNumber = 0;

    for (let i = 0; i < this.filterDefinitions.length; i++) {
      let def = this.filterDefinitions[i];

      this.filterDimensions[i] = this.crossFilterData.dimension((d) => {
        return (
          (def.isDate ? moment(d[def.propertyName]).startOf('day') : d[def.propertyName]) ||
          (def.ranges ? nullDataNumber : nullData)
        );
      });
    }

    this.setSelections();
  }

  setSelections() {
    for (let i = 0; i < this.filterDefinitions.length; i++) {
      let definition = this.filterDefinitions[i];
      let data: any;
      if (!definition.rangeDivisor && !definition.dateDiff && !definition.ranges) {
        data = this.filterDimensions[i].group().all();
      } else if (definition.rangeDivisor) {
        data = this.filterDimensions[i]
          .group((x) => {
            let val = Math.ceil((x || 0) / definition.rangeDivisor) * definition.rangeDivisor;
            return val || 1;
          })
          .all();
      } else if (definition.dateDiff) {
        data = this.filterDimensions[i]
          .group((x) => {
            let today = moment().startOf('day');
            let xDate = moment(x).startOf('day');
            let days = xDate.diff(today, 'days');

            return days;
          })
          .all();
      } else if (definition.ranges) {
        data = this.filterDimensions[i]
          .group((x) => {
            let val = x; // (x || 1);
            let groupVal: number = undefined;

            for (let k = 0; k < definition.ranges.length; k++) {
              let range = definition.ranges[k];

              if (val >= range.min && val <= range.max) {
                groupVal = range.groupValue;
                break;
              }
            }

            if (!groupVal) {
              return val;
            } else {
              return groupVal;
            }
          })
          .all();
      }

      let dataArray = data.filter(
        (x) =>
          x.value > 0 ||
          (this.selectedFilters[i]
            ? this.selectedFilters[i]
                .map((x) => {
                  return x.value;
                })
                .indexOf(x.key) >= 0
            : false),
      );

      this.filterGroups[i] = {
        name: definition.title,
        data: dataArray,
        noRangeCheck: definition.noRangeCheck,
        facetOpen: true,
        selectItems: dataArray.map((x) => {
          if (!definition.rangeDivisor && !definition.ranges) {
            let lbl: string = x.key;

            if (definition.isDate) {
              lbl = moment(x.key).startOf('day').format('ddd DD MMM YYYY');
            } else if (definition.dateDiff) {
              lbl = `${x.key} days`;
            }

            return {
              label: lbl,
              count: x.value,
              value: definition.isDate ? moment(x.key).startOf('day').toISOString() : x.key,
            } as SelectItem;
          } else if (definition.rangeDivisor) {
            let numVal = parseFloat(x.key);

            // calculate label by value
            if (numVal <= definition.rangeDivisor) {
              return {
                label: `Up to ${definition.rangeDivisor}${definition.descriptor}`,
                count: x.value,
                value: x.key,
              } as SelectItem;
            } else {
              let min = numVal;
              let max = numVal + definition.rangeDivisor;
              let lbl = `${min}-${max}${definition.descriptor}`;

              return {
                label: lbl,
                count: x.value,
                value: x.key,
              } as SelectItem;
            }
          } else if (definition.ranges) {
            for (let j = 0; j < definition.ranges.length; j++) {
              if (definition.ranges[j].groupValue == x.key) {
                return {
                  label: definition.ranges[j].label,
                  count: x.value,
                  value: x.key,
                } as SelectItem;
              }
            }

            return {
              label: x.key,
              count: x.value,
              value: x.key,
            } as SelectItem;
          }
        }),
      };

      if (!this.filterGroups[i].noRangeCheck) {
        this.filterGroups[i].selectItems.forEach((x) => {
          x.dataOutOfRange = this.dataOutOfRange(x);
        });
      }

      this.resetSelectedItems(i);

      // add the selected items at top of list then the unselected
      this.orderSelectedUnselectedItems(i);
    }
  }

  orderSelectedUnselectedItems(index: number) {
    let reordered = [];
    let selectedFilters = this.filterGroups[index].selectItems.filter((x) =>
      this.selectedFilters[index] ? this.selectedFilters[index].indexOf(x) >= 0 : false,
    );
    let unselectedFilters = this.filterGroups[index].selectItems.filter((x) =>
      this.selectedFilters[index] ? this.selectedFilters[index].indexOf(x) == -1 : false,
    );

    reordered.push(...selectedFilters, ...unselectedFilters);

    this.filterGroups[index].selectItems = reordered;
  }

  applyFilter(tableIndex: number, value: string, field: string, method): void {
    let facetTable = this.facetTables.toArray()[tableIndex];

    facetTable.filter(value, field, method);

    // store the filter in the definitions array so it can be reapplied when filters are refreshed
    this.filterDefinitions[tableIndex].tableFilter = { value, field, method };
  }

  handleFilter(event, total) {}

  resetSelectedItems(i: number) {
    // reset selected items to reflect current filter
    let resetItems = [];

    if (this.filterGroups[i]) {
      for (let j = 0; j < this.filterGroups[i].selectItems.length; j++) {
        let item = this.filterGroups[i].selectItems[j];

        if (this.selectedFilters[i] && typeof this.selectedFilters[i].forEach === 'function') {
          this.selectedFilters[i].forEach((x) => {
            if (x.value == item.value) {
              resetItems.push(item);
            }
          });
        }
      }
    }

    this.selectedFilters[i] = resetItems;

    if (!(i in this.isFacetOpen)) {
      this.isFacetOpen[i] = resetItems.length > 0;
    }
  }

  loadFromStorage() {
    if (this.loadedFromQuery) {
      this.logger.trace('not loading from storage, filters loaded from query');
      return;
    }

    this.logger.trace('loadFromStorage()');
    let stored = JSON.parse(localStorage.getItem('supplier-planning-tool'));
    if (stored) {
      this.selectedFilters = stored;
    }

    this.setFiltersFromSelection();
  }

  setFiltersFromSelection() {
    this.settingFilters = true;

    setTimeout(() => {
      // Call setTimeout to run code asynchronously
      for (let i = 0; i < this.selectedFilters.length; i++) {
        this.setDimensionFilter(i);
        this.resetSelectedItems(i);
      }
      this.populateWorkingSet(false);
      this.changeDetectorRef.detectChanges();

      this.settingFilters = false; // Reset before leaving callback method
    }, 10);
  }

  saveToStorage() {
    localStorage.setItem('supplier-planning-tool', JSON.stringify(this.selectedFilters));
  }

  viewJob(jobId) {
    window.open('/app/jobscreen/' + jobId);
  }

  vehicleCountPostfix(item, value) {
    return this.itemsCountPostfix(item, value, item.vehiclesNum);
  }

  itemsCountPostfix(item, value, count) {
    if (value == null || value == '' || count < 2) return value;
    return value + ' (+' + (count - 1) + ')';
  }

  sortFilter(index: number) {
    this.sortType[index] = !this.sortType[index];
    let filterGroup = this.filterGroups[index];

    if (this.sortType[index]) {
      filterGroup.selectItems = orderBy(
        filterGroup.selectItems,
        (o) => {
          return o.count;
        },
        'desc',
      );
    } else {
      filterGroup.selectItems = orderBy(
        filterGroup.selectItems,
        (o) => {
          return o.value;
        },
        'asc',
      );
    }

    // set selecteditem positions to top of array
    this.orderSelectedUnselectedItems(index);

    this.resetSelectedItems(index);
  }

  clearAllFilters(selections = null) {
    this.settingFilters = true;
    this.selectedJobs = [];
    this.inputTasks = [];

    setTimeout(() => {
      // Call setTimeout to run code asynchronously
      this.selectedFilters.fill(null);
      this.clearDimensions();

      this.populateWorkingSet();

      this.changeDetectorRef.detectChanges();
      this.settingFilters = false; // Reset before leaving callback method

      if (selections) {
        this.selectedFilters = selections;
        this.setFiltersFromSelection();
      }
    }, 10);
  }

  dataOutOfRange(data): boolean {
    let format = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
    let date = moment(data.value, format, true);
    let isDate = date.isValid();

    if (isDate) {
      return date < moment().subtract(1, 'd');
    } else if (this.isNumeric(data.value)) {
      return data.value < 0;
    }

    return false;
  }

  isNumeric(num) {
    num = '' + num; //coerce num to be a string
    let result = !isNaN(num) && !isNaN(parseFloat(num));
    return result;
  }

  getSelectedFiltersString(i: number) {
    return this.selectedFilters[i]
      .map(
        (x) =>
          '<div style="margin-top: 0px; margin-bottom: 4px; padding-top: 0px; padding-bottom: 4px; border-bottom: 1px solid #666;">' +
          x.label +
          '</div>',
      )
      .join('');
  }

  selectedJobChanged(data) {
    const exists = this.selectedJobs.find((x) => x.jobId == data.jobId);

    if (exists != null) {
      console.log('REMOVING JOB');
      this.selectedJobs = this.selectedJobs.filter((x) => x.jobId != data.jobId);
    } else {
      this.selectedJobs.push({
        jobId: data.jobId,
        supplierId: data.supplierId,
      });

      // Force Angular update
      this.selectedJobs = [...this.selectedJobs];
    }
  }

  isJobSelected(jobId: number) {
    return this.selectedJobs.find((x) => x.jobId == jobId);
  }

  linkedJob(task) {
    // Is there a job subsequent to this one
    return (
      this.resultSet.filter((x) => x.jobId == task.jobId && x.sequence > task.sequence).length > 0
    );
  }

  linkedToPrevious(task) {
    // Is there a task previous to this one in this job
    return (
      this.resultSet.filter((x) => x.jobId == task.jobId && x.sequence < task.sequence).length > 0
    );
  }

  applyInput(i: number, value: any) {
    const propertyName = this.filterDefinitions[i].propertyName;

    if (
      propertyName == 'pickupDistance1' ||
      propertyName == 'pickupDistance2' ||
      propertyName == 'dropoffDistance1' ||
      propertyName == 'dropoffDistance2'
    ) {
      this.isFacetLoading[i] = true;

      if (value.length > 0) {
        this.vehicleAddressService.GetVehicleAddress(value).then((x) => {
          this.applyInputUpdated(x, i, propertyName, value);
        });
      } else {
        this.applyInputUpdated(null, i, propertyName, value);
      }
    }
  }

  applyInputUpdated(x, i, propertyName, value) {
    this.userLatitude[propertyName] = x && x.latitude ? x.latitude : null;
    this.userLongitude[propertyName] = x && x.longitude ? x.longitude : null;
    this.userLocation[propertyName] = value;
    this.updateFacets();
    this.isFacetOpen[i] = true;
    this.isFacetLoading[i] = false;
  }

  updateDistances() {
    this.allData.forEach((x) => {
      Object.keys(this.userLocation).forEach((distanceKey) => {
        console.log('LAT ', this.userLatitude);
        console.log('LON ', this.userLongitude);
        console.log('DK ', distanceKey);

        let taskLat = 0;
        let taskLng = 0;

        if (distanceKey == 'pickupDistance1') {
          taskLat = x.fromLatitude;
          taskLng = x.fromLongitude;
        } else {
          taskLat = x.toLatitude;
          taskLng = x.toLongitude;
        }

        if (!this.userLatitude[distanceKey]) {
          x[distanceKey] = null;
        } else {
          x[distanceKey] = this.vehicleAddressService.calculateDistance(
            taskLat,
            taskLng,
            this.userLatitude[distanceKey],
            this.userLongitude[distanceKey],
          );
        }
      });
    });
  }
}
